// src/pages/PrivacyPolicy.jsx
import React from 'react';
import '../assets/css/global.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <section className="py-5 about_pg">
        <br/><br/><br/><br/>
        <div className="container-xl">
          <div className="row">
            <div className="col-md-12">
              <h1 className="text-center mb-4 col_red">Privacy Policy</h1>
              <p className="text-center col_light mb-5">
                <strong>Effective Date:</strong> October 20, 2025
              </p>

              <div className="content-section">
                <h3 className="col_red">1. Introduction</h3>
                <p className="col_light">
                  Welcome to Spono ("we," "our," or "us"). We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application and web platform (collectively, the "Service").
                </p>
                <p className="col_light">
                  By using Spono, you agree to the collection and use of information in accordance with this Privacy Policy. If you do not agree with our policies and practices, please do not use our Service.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">2. Information We Collect</h3>
                
                <h5 className="col_red mt-4">2.1 Personal Information</h5>
                <p className="col_light">
                  When you register for an account, we collect:
                </p>
                <ul className="col_light">
                  <li>Name</li>
                  <li>Email address</li>
                  <li>Location</li>
                  <li>Profile picture (optional)</li>
                  <li>Phone number (optional)</li>
                  <li>Bio/description (optional)</li>
                </ul>

                <h5 className="col_red mt-4">2.2 Event Information</h5>
                <p className="col_light">
                  When you check in to events or upload content, we collect:
                </p>
                <ul className="col_light">
                  <li>Event check-in data and QR code scans</li>
                  <li>Photos and videos you upload</li>
                  <li>Event attendance history</li>
                  <li>Timestamps and geolocation data (with your permission)</li>
                </ul>

                <h5 className="col_red mt-4">2.3 Automatically Collected Information</h5>
                <p className="col_light">
                  When you use our Service, we automatically collect:
                </p>
                <ul className="col_light">
                  <li>Device information (model, operating system, unique device identifiers)</li>
                  <li>IP address</li>
                  <li>Browser type and version</li>
                  <li>Usage data and analytics</li>
                  <li>Crash reports and performance data</li>
                </ul>
              </div>

              <div className="content-section">
                <h3 className="col_red">3. How We Use Your Information</h3>
                <p className="col_light">We use the collected information for:</p>
                <ul className="col_light">
                  <li><strong>Service Provision:</strong> To create and manage your account, process check-ins, and deliver personalized event experiences</li>
                  <li><strong>Communication:</strong> To send you event notifications, updates, and important service announcements</li>
                  <li><strong>Personalization:</strong> To customize your experience and show relevant events and content</li>
                  <li><strong>Analytics:</strong> To understand how users interact with our Service and improve functionality</li>
                  <li><strong>Security:</strong> To detect, prevent, and address technical issues, fraud, and security threats</li>
                  <li><strong>Legal Compliance:</strong> To comply with applicable laws and regulations</li>
                </ul>
              </div>

              <div className="content-section">
                <h3 className="col_red">4. Camera and Photo Library Access</h3>
                <p className="col_light">
                  Spono requests access to your device's camera and photo library to enable the following features:
                </p>
                <ul className="col_light">
                  <li><strong>Camera:</strong> To scan QR codes for event check-ins and capture photos/videos during events</li>
                  <li><strong>Photo Library:</strong> To upload and share your event moments, and to select profile pictures</li>
                  <li><strong>Microphone:</strong> To record videos with audio during events</li>
                </ul>
                <p className="col_light">
                  You can manage these permissions in your device settings at any time. Denying access to these features may limit certain functionality of the app.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">5. Data Sharing and Disclosure</h3>
                
                <h5 className="col_red mt-4">5.1 With Event Organizers</h5>
                <p className="col_light">
                  When you check in to an event, your name, profile information, and check-in timestamp are shared with the event organizer to facilitate event management.
                </p>

                <h5 className="col_red mt-4">5.2 With Other Users</h5>
                <p className="col_light">
                  Your public profile information (name, profile picture, bio) and content you choose to share publicly may be visible to other users attending the same events.
                </p>

                <h5 className="col_red mt-4">5.3 Service Providers</h5>
                <p className="col_light">
                  We may share your information with third-party service providers who perform services on our behalf, such as:
                </p>
                <ul className="col_light">
                  <li>Cloud storage providers</li>
                  <li>Analytics services</li>
                  <li>Email service providers</li>
                  <li>Payment processors (for premium features)</li>
                </ul>

                <h5 className="col_red mt-4">5.4 Legal Requirements</h5>
                <p className="col_light">
                  We may disclose your information if required by law, court order, or governmental regulation, or to protect the rights, property, or safety of Spono, our users, or others.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">6. Data Security</h3>
                <p className="col_light">
                  We implement industry-standard security measures to protect your personal information, including:
                </p>
                <ul className="col_light">
                  <li>Encryption of data in transit and at rest</li>
                  <li>Secure authentication with JWT tokens</li>
                  <li>Regular security audits and updates</li>
                  <li>Access controls and authentication requirements</li>
                </ul>
                <p className="col_light">
                  However, no method of transmission over the Internet or electronic storage is 100% secure. While we strive to protect your information, we cannot guarantee absolute security.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">7. Data Retention</h3>
                <p className="col_light">
                  We retain your personal information for as long as necessary to provide our Service and fulfill the purposes outlined in this Privacy Policy. You may request deletion of your account and associated data at any time by contacting us at privacy@spono.ai.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">8. Your Rights and Choices</h3>
                <p className="col_light">You have the right to:</p>
                <ul className="col_light">
                  <li><strong>Access:</strong> Request access to the personal information we hold about you</li>
                  <li><strong>Correction:</strong> Update or correct your personal information through your profile settings</li>
                  <li><strong>Deletion:</strong> Request deletion of your account and personal data</li>
                  <li><strong>Opt-Out:</strong> Unsubscribe from marketing communications</li>
                  <li><strong>Data Portability:</strong> Request a copy of your data in a portable format</li>
                </ul>
                <p className="col_light">
                  To exercise these rights, please contact us at privacy@spono.ai.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">9. Children's Privacy</h3>
                <p className="col_light">
                  Our Service is not intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If we become aware that we have collected personal information from a child under 13, we will take steps to delete such information promptly.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">10. International Data Transfers</h3>
                <p className="col_light">
                  Your information may be transferred to and processed in countries other than your country of residence. These countries may have different data protection laws. By using our Service, you consent to the transfer of your information to our facilities and service providers globally.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">11. Changes to This Privacy Policy</h3>
                <p className="col_light">
                  We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Effective Date" above. You are advised to review this Privacy Policy periodically for any changes.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">12. Contact Us</h3>
                <p className="col_light">
                  If you have any questions about this Privacy Policy or our privacy practices, please contact us at:
                </p>
                <ul className="col_light">
                  <li><strong>Email:</strong> privacy@spono.ai</li>
                  <li><strong>Support:</strong> support@spono.ai</li>
                  <li><strong>Website:</strong> https://spono.ai</li>
                </ul>
              </div>

              <div className="text-center mt-5 mb-5">
                <p className="col_light">
                  By using Spono, you acknowledge that you have read and understood this Privacy Policy.
                </p>
              </div>
            </div>
          </div>
        </div>
        <br/><br/>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
